import { render, staticRenderFns } from "./DealBuyModal.vue?vue&type=template&id=28973e6a&"
import script from "./DealBuyModal.vue?vue&type=script&lang=ts&"
export * from "./DealBuyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports